import * as React from 'react';
import sanitizeHtml from 'sanitize-html';
import { IPost } from '../../types';

interface IProps {
	post: IPost;
}

const Default = ({ post }: IProps) => {
	const cardClasses = [
		'pfa-card-default',
		post.card_overlay && post.card_overlay_color
			? `pfa-card-default--overlay-color-${post.card_overlay_color}`
			: '',
	]
		.filter(Boolean)
		.join(' ');

	return (
		<a href={post.permalink} target="_self" rel="noreferrer" className={cardClasses}>
			<figure className="pfa-card-default__figure">
				{!!post.featured_image && (
					<span
						className="pfa-card-default__img"
						dangerouslySetInnerHTML={{ __html: post.featured_image }}
					/>
				)}
				{post.card_overlay_svg && (
					<span
						className="pfa-card-default__overlay"
						dangerouslySetInnerHTML={{ __html: post.card_overlay_svg }}
					/>
				)}
			</figure>
			<div className="pfa-card-default__content">
				{post.category?.name && (
					<p
						className="pfa-card-default__tag"
						dangerouslySetInnerHTML={{
							__html: sanitizeHtml(post.category.name),
						}}
					/>
				)}
				{post.post_title && (
					<h3
						className="pfa-card-default__title"
						dangerouslySetInnerHTML={{ __html: sanitizeHtml(post.post_title) }}
					/>
				)}
				<div className="pfa-card-default__spacer"></div>
				{post.author_name && (
					<div className="pfa-card-default__author">
						{post.author_image && (
							<span
								className="pfa-card-default__author-img"
								dangerouslySetInnerHTML={{ __html: post.author_image }}
							/>
						)}
						<span className="pfa-card-default__author-name">{post.author_name}</span>
					</div>
				)}
			</div>
		</a>
	);
};

Default.displayName = 'Default';

export default Default;
